export default __webpack_public_path__ + "static/harvard-ef8f63c6d32a640edcd3803f33202c72.svg";